import { render } from "./AvSelector.vue?vue&type=template&id=6077f1f9"
import script from "./AvSelector.vue?vue&type=script&lang=js"
export * from "./AvSelector.vue?vue&type=script&lang=js"
script.render = render

export default script